import React from 'react'

const Homeattendence = () => {
  return (
    <section id="features-details" className="features-details section">
      <div className="container">
        <div className="row gy-4 justify-content-between features-item">
          <div className="col-lg-5 d-flex align-items-center order-2 order-lg-1">
            <div className="content">
              <h3>TIME AND ATTENDANCE</h3>
              <p>
              </p><p>Allow time for greatness and unlock higher productivity through our integrated and advanced time and attendance management system. Similarly create a digitally seamless onboarding experience so that shortens the new employees’ time to productivity.Then set them up for success and build delightful employee journeys from day one.</p>
              <p />
              <ul>
                <li><i className="bi bi-easel flex-shrink-0" /> Enhanced employee accountability</li>
                <li><i className="bi bi-patch-check flex-shrink-0" /> Accurate payroll processing</li>
                <li><i className="bi bi-brightness-high flex-shrink-0" /> Attendance policies that are transparent and consistent</li>
                <li><i className="bi bi-brightness-high flex-shrink-0" /> Attendance policies that are transparent and consistent</li>
              </ul>
              <p />
              <a href="#" className="btn more-btn">Read More</a>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2">
            <img src="https://sigohrmlpadmin.loopring.in/front/images/homeattendencemanagements/34695.png" className="img-fluid" alt />
          </div>
        </div>{/* Features Item */}
      </div>
    </section>

  )
}

export default Homeattendence
